import { connect } from 'react-redux';

import { TThunkDispatch, IApplicationState, ISendFeedbackParams } from '../../types/redux';
import { Feedback, IFeedbackProps } from './Feedback';
import { setDimensionsFeedback, sendFeedback } from '../../actions/feedback';
import { defaultState } from '../../reducers/feedback';

type TStoreProps = Pick<IFeedbackProps, 'screen' | 'isLoading' | 'isSendError' | 'isVisibleForm'>;
type TDispatchProps = Pick<IFeedbackProps, 'setDimensionsFeedback' | 'sendFeedback'>;

export function mapStateToProps(state: IApplicationState): TStoreProps {
  const isVisibleForm =
    typeof state.feedback.isVisibleForm === 'boolean'
      ? state.feedback.isVisibleForm
      : (defaultState.isVisibleForm as boolean);

  return {
    screen: state.feedback.screen,
    isLoading: state.feedback.isLoading,
    isSendError: state.feedback.isSendError,
    isVisibleForm,
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TDispatchProps {
  return {
    setDimensionsFeedback: (top: number, height: number) => dispatch(setDimensionsFeedback(top, height)),
    sendFeedback: ({ name, phone, comment }: ISendFeedbackParams) => {
      return dispatch(sendFeedback({ name, phone, comment }));
    },
  };
}

export const FeedbackContainer = connect(mapStateToProps, mapDispatchToProps)(Feedback);
